<div class="settings-wrapper" [matMenuTriggerFor]="settingsMenu">
  <mat-icon>settings</mat-icon>

  <mat-menu #settingsMenu="matMenu" class="settings-theme-menu">
    <div class="settings-menu-wrapper">
      <p class="menu-title">auto save</p>

      <div class="slide-wrapper">
        <mat-slide-toggle
          color="warn"
        ></mat-slide-toggle>
      </div>
    </div>
  </mat-menu>
</div>
